import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowSplit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 9.99992H6.33083C6.95569 10 7.57253 10.1406 8.13568 10.4114C8.69884 10.6822 9.19388 11.0761 9.58417 11.5641L10.4158 12.6024C10.8061 13.0904 11.3012 13.4844 11.8643 13.7551C12.4275 14.0259 13.0443 14.1665 13.6692 14.1666H17.5M17.5 14.1666L15 11.6666M17.5 14.1666L15 16.6666M17.5 5.83325H13.2683C12.7687 5.83341 12.2754 5.94591 11.8251 6.16242C11.3747 6.37894 10.9788 6.69392 10.6667 7.08409L9.33417 8.74992C9.02182 9.14004 8.62575 9.45493 8.17527 9.6713C7.72479 9.88767 7.23142 9.99998 6.73167 9.99992H5M17.5 5.83325L15 3.33325M17.5 5.83325L15 8.33325",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowSplit;
